import { z } from "zod";

export const submissionActivityDateFields = [
  "candidate_contact",
  "emailSent",
  "emailReceived",
  "callInbound",
  "callOutbound",
  "interviews",
  "otherInterviews",
  "nextRound",
  "cv_sent",
] as const;
export const submissionActivityCountFields = ["interviewCount", "otherInterviewCount"] as const;
export const submissionActivityFields = [...submissionActivityDateFields, ...submissionActivityCountFields] as const;
export type SubmissionActivityField = (typeof submissionActivityFields)[number];

const dateFilter = z
  .object({
    from: z.iso.date().optional(),
    to: z.iso.date().optional(),
    missing: z.boolean().optional(),
  })
  .refine((value) => !(value.missing && (value.from || value.to)), "Missing cannot be combined with a date range")
  .refine((value) => !value.from || !value.to || value.from <= value.to, "From must be before to");
const countFilter = z
  .object({ min: z.number().int().nonnegative().optional(), max: z.number().int().nonnegative().optional() })
  .refine(
    (value) => value.min === undefined || value.max === undefined || value.min <= value.max,
    "Min must not exceed max",
  );
export const submissionActivityFiltersSchema = z.object({
  candidate_contact: dateFilter.optional(),
  emailSent: dateFilter.optional(),
  emailReceived: dateFilter.optional(),
  callInbound: dateFilter.optional(),
  callOutbound: dateFilter.optional(),
  interviews: dateFilter.optional(),
  otherInterviews: dateFilter.optional(),
  nextRound: dateFilter.optional(),
  cv_sent: dateFilter.optional(),
  interviewCount: countFilter.optional(),
  otherInterviewCount: countFilter.optional(),
});
export type SubmissionActivityFilters = z.infer<typeof submissionActivityFiltersSchema>;
